import CycleCard from './CycleCard';

export default CycleCard;
